export default {
  methods: {
    absolutizeUrl(url) {
      if (!url) return null;
      let cleanedUrl = url.replace(/^\/{2,}/, '/');
      if (/^https?:\/\//.test(cleanedUrl)) return cleanedUrl;
      return window.location.origin + cleanedUrl;
    }
  }
}
